import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ContactSection from "../components/contact/ContactSection";
import Features from "../components/home/Features";
import Hero from "../components/home/Hero";
import Overview from "../components/home/Overview";

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      handleScrollToSection(location.hash);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  const handleScrollToSection = (hash) => {
    document.querySelector(hash)?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <div>
      <Hero />

      <Features />
      <Overview />

      <ContactSection />
    </div>
  );
};

export default HomePage;
